import {
  BrandFacebook,
  BrandInstagram,
  BrandLinkedin,
  BrandTwitter
} from 'tabler-icons-react';
import stripeLogo from '../images/stripe_logo.png';
import sportspayLogo from '../images/sportspay_logo.png';

const PRODUCTION = true;
const TESTING = false;
const LOCAL_API = false;
const CONSOLE_DEBUG = false;

const COGNITO_SETTING_DEV = {
  Auth: {
    identityPoolId: 'us-east-1:5111a894-2c2c-41b1-a29a-f717eaa9aa31',
    region: 'us-east-1',
    userPoolId: 'us-east-1_Z2PFfqRF1',
    userPoolWebClientId: '624bs7emni9leiuspgcrrs9j8s',
    mandatorySignIn: true
  },
  Storage: {
    bucket: 'hockeyheadz-storage',
    region: 'us-east-1'
  }
};

const COGNITO_SETTING_PROD = {
  Auth: {
    identityPoolId: 'us-east-1:93ca516d-e2c4-4ad6-b44c-4b05604c8bd7',
    region: 'us-east-1',
    userPoolId: 'us-east-1_FAoqNjX2j',
    userPoolWebClientId: '4fdno1j1g5jukptomkdifu3gao',
    mandatorySignIn: true
  },
  Storage: {
    bucket: 'hockeyheadz-storage',
    region: 'us-east-1'
  }
};

const META_PIXEL_ID = '523029268675450';

const S3_PUBLIC_URL = 'https://hockeyheadz-storage.s3.amazonaws.com/public/';

const SPORTSHEADZ_WEBSITE_URL = 'https://sportsheadz.com';

const PASSWORD_CONSTRAINTS = {
  length: 8,
  regexList: {
    capRegex: /\w*[A-Z]/,
    numRegex: /[0-9]/,
    symRegex: /[-!$%^&*()_+|~=`{}[\]:";'<>?,./]/
  }
};

const REG_ASSOCIATION_SOCIAL_TYPES = [
  {
    pkRegAssociationSocialType: 1,
    label: 'FaceBook',
    value: 'FACEBOOK',
    icon: BrandFacebook
  },
  {
    pkRegAssociationSocialType: 2,
    label: 'Twitter',
    value: 'TWITTER',
    icon: BrandTwitter
  },
  {
    pkRegAssociationSocialType: 3,
    label: 'Instagram',
    value: 'INSTAGRAM',
    icon: BrandInstagram
  },
  {
    pkRegAssociationSocialType: 4,
    label: 'LinkedIn',
    value: 'LINKEDIN',
    icon: BrandLinkedin
  }
];

const TEST_CASE_DATA = {
  auth: {
    email: '',
    password: ''
  },
  regAssociation: { pkRegAssociation: 1, pkForm: 29 }
};

const CANADA_PROVINCE_LIST = [
  'Alberta',
  'British Columbia',
  'Manitoba',
  'New Brunswick',
  'Newfoundland and Labrador',
  'Northwest Territories',
  'Nova Scotia',
  'Nunavut',
  'Ontario',
  'Prince Edward Island',
  'Quebec',
  'Saskatchewan',
  'Yukon'
];

const USA_STATE_LIST = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming'
];

const PAYMENT_TYPE_ENUM = {
  CHEQUE: '1',
  CASH: '2',
  E_TRANSFER: '3',
  JUMPSTART: '4',
  REFUND: '5',
  INVOICE: '6',
  STRIPE: '7',
  AFTERPAY: '8',
  FORGIVENESS: '9',
  SPORTSPAY: '10',
  SPORTSPAY_INSTALLMENTS: '11',
  REIMBURSEMENT: '12',
  CREDIT: '13'
};

const OFFLINE_PAYMENT_TYPES = [
  {
    value: '1',
    label: 'Cheque'
  },
  {
    value: '2',
    label: 'Cash'
  },
  {
    value: '3',
    label: 'E-Transfer'
  },
  {
    value: '4',
    label: 'Jumpstart'
  },
  {
    value: '5',
    label: 'Refund'
  },
  {
    value: '6',
    label: 'Invoice'
  },
  {
    value: '7',
    label: 'Stripe'
  },
  {
    value: '8',
    label: 'Afterpay'
  },
  {
    value: '9',
    label: 'Forgiveness'
  },
  {
    value: '10',
    label: 'SportsPay'
  },
  {
    value: '11',
    label: 'SportsPay Installments'
  }
];

const REG_GENDER_TYPES = [
  {
    value: '1',
    label: 'All-Inclusive'
  },
  {
    value: '2',
    label: 'Girls Only'
  },
  {
    value: '3',
    label: 'Boys Only'
  }
];

const REG_FORM_SORT_TYPES = [
  {
    value: '1',
    type: 'REG_END_DATE',
    label: 'Registration End Date'
  },
  {
    value: '2',
    type: 'AGE_RESTRICTION',
    label: 'Age Restriction'
  },
  {
    value: '4',
    type: 'FORM_TITLE',
    label: 'Form Title'
  },
  {
    value: '5',
    type: 'COST',
    label: 'Cost'
  },
  {
    value: '6',
    type: 'DIVISION_NAME',
    label: 'Division Name'
  }
];

const REG_ASSOCIATION_SAVED_TEMPLATE_INPUT_TYPE = [
  {
    label: 'Account',
    value: 'account_variable'
  },
  {
    label: 'Payment',
    value: 'payment_variable'
  },
  {
    label: 'Form',
    value: 'form_variable'
  }
];

const PAYMENT_PROVIDERS = {
  stripe: {
    value: 1,
    label: 'Stripe',
    image: stripeLogo,
    description:
      'A modern online payment processor with a fast, secure checkout experience and a wide range of advanced payment features. Designed to provide a seamless experience for both customers and administrators.',
    serviceFeeDescription: '2.9% + $0.30 per transaction',
    defaultFlatServiceFee: 0.3,
    defaultPercentageServiceFee: 2.9,
    hasInstallments: true,
    canCreateNewAccounts: true,
    canChangeCurrency: true,
    canCustomizeInstallments: false,
    canCustomizeServiceFee: false
  },
  sportspay: {
    value: 2,
    label: 'SportsPay',
    image: sportspayLogo,
    description:
      'A simple and reliable online payment processor focused on keeping processing costs low. An excellent choice for organizations looking for an affordable payment solution while providing a secure checkout experience.',
    serviceFeeDescription: '2.54% or less per transaction',
    defaultFlatServiceFee: 0,
    defaultPercentageServiceFee: 2.54,
    hasInstallments: true,
    canCreateNewAccounts: false,
    canChangeCurrency: false,
    canCustomizeInstallments: true,
    canCustomizeServiceFee: true
  }
};

const PAYMENT_PROVIDER_LIST = [
  PAYMENT_PROVIDERS.stripe,
  PAYMENT_PROVIDERS.sportspay
];

const CURRENCY_TYPE_ENUM = {
  CAD: 1,
  USD: 2
};

const CURRENCY_TYPE_LIST = [
  {
    label: 'Canadian Dollar',
    fullLabel: 'Canadian Dollar (CAD $)',
    abbr: 'CAD',
    symbol: '$',
    value: CURRENCY_TYPE_ENUM.CAD
  },
  {
    label: 'US Dollar',
    fullLabel: 'US Dollar (USD $)',
    abbr: 'USD',
    symbol: '$',
    value: CURRENCY_TYPE_ENUM.USD
  }
];

const REG_FORM_SUBMISSION_MODAL_ACTIONS_ENUM = {
  view: 'VIEW',
  orderSummary: 'ORDER_SUMMARY',
  emailUser: 'EMAIL',
  refund: 'REFUND',
  changeDivision: 'CHANGE-DIVISION',
  changeOverrideEmail: 'CHANGE-EMAIL-OVERRIDE',
  invoice: 'INVOICE',
  reinstate: 'REINSTATE',
  deny: 'DENY',
  viewPayments: 'RECORD_PAYMENT',
  resendReceipt: 'RESEND_RECEIPT'
};

const PAYMENT_PROVIDER_LINE_ITEM_TYPES = {
  registration: {
    value: 1,
    label: 'Registration'
  },
  merch: {
    value: 2,
    label: 'Merch'
  },
  invoice: {
    value: 3,
    label: 'Invoice'
  },
  ecommerce: {
    value: 4,
    label: 'Ecommerce'
  }
};

const REG_FORM_CONTROL_TYPE_ENUM = {
  TEXT: 1,
  TEXT_INPUT: 2,
  DROP_DOWN: 3,
  DATE: 4,
  RADIO_GROUP: 5,
  CHECKBOX: 6,
  FILE_DOWNLOAD: 7,
  SIGNATURE: 8,
  FILE_UPLOAD: 9,
  SLIDER: 10,
  BUTTON_GROUP: 11,
  LINK: 12,
  COLOR: 13
};

const REG_FORM_CONTROL_TYPES = [
  {
    label: 'Text',
    value: REG_FORM_CONTROL_TYPE_ENUM.TEXT
  },
  {
    label: 'Text Input',
    value: REG_FORM_CONTROL_TYPE_ENUM.TEXT_INPUT
  },
  {
    label: 'Drop-down',
    value: REG_FORM_CONTROL_TYPE_ENUM.DROP_DOWN
  },
  {
    label: 'Date',
    value: REG_FORM_CONTROL_TYPE_ENUM.DATE
  },
  {
    label: 'Radio Group',
    value: REG_FORM_CONTROL_TYPE_ENUM.RADIO_GROUP
  },
  {
    label: 'Checkbox',
    value: REG_FORM_CONTROL_TYPE_ENUM.CHECKBOX
  },
  {
    label: 'File Download',
    value: REG_FORM_CONTROL_TYPE_ENUM.FILE_DOWNLOAD
  },
  {
    label: 'Signature',
    value: REG_FORM_CONTROL_TYPE_ENUM.SIGNATURE
  },
  {
    label: 'File Upload',
    value: REG_FORM_CONTROL_TYPE_ENUM.FILE_UPLOAD
  }
];

const BULK_EDIT_FIELD_TYPE_ENUM = {
  TEXT: 1,
  TEXT_PRICE: 2,
  SELECT: 3,
  SELECT_MULTIPLE: 4,
  NUMBER: 5,
  PRICE: 6,
  TEXT_INPUT: 7,
  DATE_TIME: 8,
  CHECKBOX: 9
};

const ANALYTIC_MERCH_PACKAGE_SHOWCASE_LOCATION_ENUM = {
  ASSOCIATION_PAGE_HEADER: 'ASSOCIATION_PAGE_HEADER',
  ORDER_SUMMARY: 'ORDER_SUMMARY',
  CART_FOOTER: 'CART_FOOTER',
  FORM_SUBMISSION_FOOTER: 'FORM_SUBMISSION_FOOTER',
  PRODUCT_DETAILS_PAGE_FOOTER: 'PRODUCT_DETAILS_PAGE_FOOTER',
  CART_NAVIGATION_TO_ASSOCIATION_PAGE: 'CART_NAVIGATION_TO_ASSOCIATION_PAGE'
};

const REG_PERMISSION_ENUM = {
  MY_LEAGUE: 1,
  COUPONS: 2,
  FORMS: 3,
  FINANCIALS: 4,
  REPORTS: 5,
  EVALUATIONS: 6,
  BRANDING: 7,
  SUPER_ADMIN: 8
};

const REG_PERMISSION_LIST = [
  {
    label: 'My League',
    value: REG_PERMISSION_ENUM.MY_LEAGUE,
    description: 'Setup and manage registration seasons, divisions, and teams.'
  },
  {
    label: 'Coupons',
    value: REG_PERMISSION_ENUM.COUPONS,
    description: 'Create and manage registration coupons.'
  },
  {
    label: 'Forms',
    value: REG_PERMISSION_ENUM.FORMS,
    description: 'Create and manage registration forms.'
  },
  {
    label: 'Financials',
    value: REG_PERMISSION_ENUM.FINANCIALS,
    description: 'Manage financials including payments and refunds.'
  },
  {
    label: 'Reports',
    value: REG_PERMISSION_ENUM.REPORTS,
    description: 'Generate reports about your association.'
  },
  {
    label: 'Evaluations',
    value: REG_PERMISSION_ENUM.EVALUATIONS,
    description: 'Scout and evaluate registrants.'
  },
  {
    label: 'Branding',
    value: REG_PERMISSION_ENUM.BRANDING,
    description: 'Change the look and feel of your association page.'
  },
  {
    label: 'Super Admin (Full Access Control)',
    value: REG_PERMISSION_ENUM.SUPER_ADMIN,
    description:
      'Complete and unrestricted access to all features and settings.'
  }
];

const REG_SCOUT_REPORT_QUESTION_TYPE = {
  METRIC: 1,
  ATTRIBUTE: 2
};

const DEFUALT_EVALUATION_BUTTON_OPTIONS = [
  { key: 1, value: 'Poor', sort: 1 },
  { key: 2, value: 'Average', sort: 2 },
  { key: 3, value: 'Excellent', sort: 3 }
];

const REG_SCOUT_REPORT_QUESTION_RESTRICTION_CONDITION_ENUM = {
  EQUAL: '1',
  NOT_EQUAL: '2'
};

const REG_SCOUT_REPORT_QUESTION_RESTRICTION_CONDITIONS = [
  {
    value: REG_SCOUT_REPORT_QUESTION_RESTRICTION_CONDITION_ENUM.EQUAL,
    label: 'Equal to'
  },
  {
    value: REG_SCOUT_REPORT_QUESTION_RESTRICTION_CONDITION_ENUM.NOT_EQUAL,
    label: 'Not equal to'
  }
];

const REG_FORM_SUBMISSION_STATUS_ENUM = {
  PENDING: '1',
  ACCEPTED: '2',
  DENIED: '3',
  REFUNDED: '4',
  PENDING_PAYMENT: '5'
};

const REG_FORM_SUBMISSION_INVOICE_STATUS_ENUM_VALUES = {
  PENDING: '1',
  PAID: '2',
  VOID: '3',
  UNCOLLECTIBLE: '4'
};

const REG_FORM_SUBMISSION_INVOICE_STATUS_ENUM = {
  PENDING: 'PENDING',
  PAID: 'PAID',
  VOID: 'VOID',
  UNCOLLECTIBLE: 'UNCOLLECTIBLE'
};

const REG_FORM_SUBMISSION_INVOICE_STATUS_LIST = [
  {
    label: 'Pending',
    color: 'blue',
    value: REG_FORM_SUBMISSION_INVOICE_STATUS_ENUM.PENDING
  },
  {
    label: 'Paid',
    color: 'green',
    value: REG_FORM_SUBMISSION_INVOICE_STATUS_ENUM.PAID
  },
  {
    label: 'Void',
    color: 'red',
    value: REG_FORM_SUBMISSION_INVOICE_STATUS_ENUM.VOID
  },
  {
    label: 'Uncollectible',
    color: 'orange',
    value: REG_FORM_SUBMISSION_INVOICE_STATUS_ENUM.UNCOLLECTIBLE
  }
];

const VIEW_ACTIONS_ENUM = {
  VIEW: 'VIEW',
  CREATE: 'CREATE',
  EDIT: 'EDIT',
  DUPLICATE: 'DUPLICATE',
  DELETE: 'DELETE',
  RESTORE: 'RESTORE',
  EXPORT: 'EXPORT',
  IMPORT: 'IMPORT',
  CHANGE_STATUS: 'CHANGE_STATUS',
  ARCHIVE: 'ARCHIVE',
  UPLOAD: 'UPLOAD',
  ERROR: 'ERROR',
  DISCARD: 'DISCARD',
  REFUND: 'REFUND'
};

const REG_RESOURCE_TYPE_ENUM = { SUBMISSION: '1' };

const REG_RESOURCE_TYPE_LOG_ENUM = {
  USER_NOTE: '1',
  CHANGE_HISTORY: '2',
  SYSTEM_LOG: '3'
};

const REG_EXTERNAL_CONNECTION_TYPE_ENUM = { HOCKEY_CANADA: '1' };

const PRODUCT_CATEGORY_TYPE_ENUM = {
  ACCESSORIES: 1,
  APPAREL: 2,
  CUSTOMIZATION_SERVICES: 3,
  EVENT_SUPPLIES: 4,
  FAN_GEAR: 5,
  FITNESS_TRAINING: 6,
  NUTRITION_HEALTH: 7,
  SPORTS_EQUIPMENT: 8,
  TEAM_SUPPLIES: 9,
  DECORATION: 10,
  MISC: 11,
  DRINKWARE: 12
};

const ECOM_PRODUCT_STATUS_ENUM = {
  ACTIVE: '1',
  DRAFT: '2',
  ARCHIVED: '3',
  PENDING_ACTION: '4'
};

const SERVICE_TYPE_ENUM = {
  WEBSITE: '1',
  PLAYER_REG: '2',
  MOBILE_APP: '3',
  STORE: '4',
  SERVICE_API: '5',
  PAYMENT_API: '6',
  B2B_WEBSITE: '7'
};

const PLATFORM_PK_SERVICE = SERVICE_TYPE_ENUM.PLAYER_REG;

const ECOM_ORDER_STATUS_ENUM = {
  PROCESSING: '1',
  SUCCEEDED: '2',
  CANCELLED: '3',
  ACCUMULATING: '4',
  FULFILLED: '5',
  COMPLETED_OFFLINE: '6'
};

const ECOM_ORDER_PRODUCT_STATUS_ENUM = {
  PENDING: '1',
  CANCELLED: '2',
  REFUNDED: '3',
  SHIPPED: '4',
  DELIVERED: '5',
  ACCEPTED: '6',
  TRANSFERRED: '7'
};

const ECOM_WEBSTORE_SECTION_BOUND_TYPE = {
  HEADER: 1,
  BODY: 2,
  FOOTER: 3
};

const ECOM_WEBSTORE_SECTION_TYPE_ENUM = {
  HEADER: 1,
  ANNOUNCEMENT_BAR: 2,
  FEATURED_COLLECTION: 3,
  FEATURED_PRODUCT: 4,
  COLLECTION_LIST: 5,
  RICH_TEXT: 6,
  IMAGE_WITH_TEXT: 7,
  IMAGE_BANNER: 8,
  SLIDESHOW: 9,
  COLLAGE: 10,
  MULTICOLUMN: 11,
  MULTIROW: 12,
  COLLAPSIBLE_CONTENT: 13,
  EMAIL_SIGNUP: 14,
  CONTACT_FORM: 15,
  VIDEO: 16,
  BLOG_POSTS: 17,
  PAGE: 18,
  FOOTER: 19,
  ACCOUNT_CONTENT: 20,
  PRODUCT_INFORMATION: 21,
  CHECKOUT_CONTENT: 22,
  PRODUCT_GRID: 23,
  RESOURCE_BANNER: 24,
  COLLECTION_GRID: 25,
  LAYERED_BANNER: 26,
  DESIGN_GRID: 27,
  DESIGN_LIST: 28,
  FEATURED_DESIGN: 29,
  CATEGORY_LIST: 30,
  CATEGORY_GRID: 31,
  BREADCRUMBS: 32
};

const ECOM_WEBSTORE_SECTION_BLOCK_TYPE_ENUM = {
  TEXT_LINK: 1,
  TEXT_OVER_IMAGE: 2,
  HEADING: 3,
  SUBHEADING: 4,
  TITLE: 5,
  TEXT: 6,
  CAPTION: 7,
  BUTTON_GROUP: 8,
  EMAIL_FORM: 9,
  PRICE: 10,
  VARIANT_PICKER: 11,
  QUANTITY_SELECTOR: 12,
  BUY_BUTTONS: 13,
  SKU: 14,
  RATING: 15,
  ICON_WITH_TEXT: 16,
  IMAGE: 17,
  COLLECTION: 18,
  PRODUCT: 19,
  VIDEO: 20,
  COLUMN_CONTENT: 21,
  ROW_CONTENT: 22,
  ACCORDION: 23,
  MENU: 24,
  BRAND_INFORMATION: 25,
  DESCRIPTION: 26,
  INVENTORY_STATUS: 27,
  CONTENT_CARD: 28,
  VENDOR_TITLE: 29,
  DESIGN: 30,
  CATEGORY: 31,
  SHARE_BUTTONS: 32
};

const ECOM_WEBSTORE_PAGE_TYPE_ENUM = {
  HOME: 1,
  PRODUCT: 2,
  COLLECTION: 3,
  COLLECTION_LIST: 4,
  CART: 5,
  CHECKOUT: 6,
  PAGE: 7,
  BLOG: 8,
  BLOG_POST: 9,
  SEARCH: 10,
  PASSWORD: 11,
  NOT_FOUND: 12,
  CUSTOMER_LOGIN: 13,
  CUSTOMER_REGISTER: 14,
  CUSTOMER_RESET_PASSWORD: 15,
  CUSTOMER_ACCOUNT: 16,
  CUSTOMER_ORDERS: 17,
  CUSTOMER_ORDER_DETAILS: 18,
  CUSTOMER_ADDRESSES: 19,
  DESIGN: 20,
  DESIGN_LIST: 21,
  EXPLORE: 22,
  CATEGORY: 23,
  CATEGORY_LIST: 24,
  ABOUT: 25
};

const ECOM_ENTITY_TYPES = {
  ecomStoreThemeColorScheme: 'ecomStoreThemeColorScheme',
  ecomStoreMedia: 'ecomStoreMedia',
  ecomStoreProduct: 'ecomStoreProduct',
  ecomStoreCollection: 'ecomStoreCollection',
  ecomStoreDesign: 'ecomStoreDesign',
  ecomStorePage: 'ecomStorePage',
  ecomStoreMenu: 'ecomStoreMenu',
  ecomCategory: 'ecomCategory'
};

const HEADING_SIZE_STYLE_ENUM = {
  EXTRA_SMALL: 'extra_small',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  EXTRA_LARGE: 'extra_large',
  HUGE: 'huge'
};

const ECOM_PRODUCT_BUNDLE_TYPE_ENUM = {
  FIXED_BUNDLE: '1',
  VOLUME_DISCOUNT: '2',
  MIX_AND_MATCH: '3',
  FREQUENTLY_BOUGHT_TOGETHER: '4',
  BUY_X_GET_Y: '5'
};

const ECOM_PRODUCT_BUNDLE_TYPE_LIST = [
  {
    label: 'Fixed Bundle',
    value: ECOM_PRODUCT_BUNDLE_TYPE_ENUM.FIXED_BUNDLE,
    description:
      'A predefined set of products sold together at a single fixed price. Customers can select available variations (e.g., size or color) for each item, but cannot add, remove, or change the products included in the bundle.'
  },
  {
    label: 'Mix and Match',
    value: ECOM_PRODUCT_BUNDLE_TYPE_ENUM.MIX_AND_MATCH,
    description:
      'A customizable bundle that allows customers to select specific products, variations, or quantities from a defined collection—often unlocking tiered or dynamic discounts based on their selections.'
  },
  {
    label: 'Buy X Get Y',
    value: ECOM_PRODUCT_BUNDLE_TYPE_ENUM.BUY_X_GET_Y,
    description:
      'A promotional offer where purchasing a specified quantity of product X qualifies the customer to receive product Y at a free or discounted price.'
  },
  {
    label: 'Volume Discount',
    value: ECOM_PRODUCT_BUNDLE_TYPE_ENUM.VOLUME_DISCOUNT,
    description:
      'A quantity-based pricing model where the unit price decreases as customers purchase higher quantities, incentivizing bulk purchases.'
  },
  {
    label: 'Frequently Bought Together',
    value: ECOM_PRODUCT_BUNDLE_TYPE_ENUM.FREQUENTLY_BOUGHT_TOGETHER,
    description:
      'A curated group of complementary products commonly purchased together, presented as a convenient set and typically offered with a bundled discount.'
  }
];

const ECOM_DISCOUNT_TYPE_ENUM = {
  SET_PRICE: '1',
  PERCENTAGE_DISCOUNT: '2',
  FLAT_DISCOUNT: '3',
  FREE_GIFT: '4',
  NO_DISCOUNT: '5'
};

const ECOM_DISCOUNT_TYPE_LIST = [
  {
    value: ECOM_DISCOUNT_TYPE_ENUM.NO_DISCOUNT,
    label: 'No discount'
  },
  {
    value: ECOM_DISCOUNT_TYPE_ENUM.PERCENTAGE_DISCOUNT,
    label: 'Percentage discount'
  },
  {
    value: ECOM_DISCOUNT_TYPE_ENUM.FLAT_DISCOUNT,
    label: 'Flat discount'
  },
  {
    value: ECOM_DISCOUNT_TYPE_ENUM.SET_PRICE,
    label: 'Set price'
  },
  {
    value: ECOM_DISCOUNT_TYPE_ENUM.FREE_GIFT,
    label: 'Free gift'
  }
];

const TEAM_LAUNCH_STATUS = {
  NO_ASSIGNED_MEMBERS: {
    value: 'NO_ASSIGNED_MEMBERS',
    label: 'No assigned members',
    color: 'black'
  },
  READY_TO_LAUNCH: {
    value: 'READY_TO_LAUNCH',
    label: 'Ready to launch',
    color: '#eca70a'
  },
  PENDING_RELAUNCH: {
    value: 'PENDING_RELAUNCH',
    label: 'Pending relaunch',
    color: '#eca70a'
  },
  LAUNCHED: {
    value: 'LAUNCHED',
    label: 'Launched',
    color: 'green'
  },
  DELETED: {
    value: 'DELETED',
    label: 'Deleted externally',
    color: '#C40000'
  },
  NAME_MISMATCH: {
    value: 'NAME_MISMATCH',
    label: 'Name mismatch',
    color: '#C40000',
    getSubLabel: (teamName, externalTeam) =>
      externalTeam ? `${externalTeam.team.name} (External)` : null
  }
};

const PAYMENT_PLAN_TYPE_ENUM = {
  CHECKOUT: '1',
  REGISTRATION_FORM: '2'
};

const PAYMENT_PLAN_TYPE_LIST = [
  {
    value: PAYMENT_PLAN_TYPE_ENUM.CHECKOUT,
    label: 'Checkout',
    description:
      'Registrants select a payment plan during checkout. The selected plan applies installments to the entire order total.',
    disclaimer: 'Unavailable when a registration form payment plan is selected.'
  },
  {
    value: PAYMENT_PLAN_TYPE_ENUM.REGISTRATION_FORM,
    label: 'Registration Form',
    description:
      'Payment plans are selected within each registration form and handled independently.',
    disclaimer:
      'Checkout payment plans are unavailable when registration form payment plans are selected.'
  }
];

const PAYMENT_AMOUNT_TYPE_ENUM = {
  FIXED: '1',
  PERCENTAGE: '2',
  REMAINING_BALANCE: '3'
};

const PAYMENT_AMOUNT_TYPE_LIST = [
  {
    value: PAYMENT_AMOUNT_TYPE_ENUM.FIXED,
    label: 'Fixed amount'
  },
  {
    value: PAYMENT_AMOUNT_TYPE_ENUM.PERCENTAGE,
    label: 'Percentage of total'
  },
  {
    value: PAYMENT_AMOUNT_TYPE_ENUM.REMAINING_BALANCE,
    label: 'Remaining Balance',
    hideOnFirstInstallment: true,
    isLimitedToOneInstallment: true
  }
];

const PAYMENT_DUE_TYPE_ENUM = {
  IMMEDIATE: '1',
  DAYS_AFTER_PREVIOUS: '2',
  DAYS_AFTER_REGISTRATION: '3',
  MONTHS_AFTER_PREVIOUS: '4',
  MONTHS_AFTER_REGISTRATION: '5',
  FIXED_DATE: '6'
};

const PAYMENT_DUE_TYPE_LIST = [
  {
    value: PAYMENT_DUE_TYPE_ENUM.IMMEDIATE,
    label: 'Immediate',
    isFirstInstallmentOnly: true
  },
  {
    value: PAYMENT_DUE_TYPE_ENUM.DAYS_AFTER_PREVIOUS,
    label: 'Days after previous',
    isSubsequentInstallmentsOnly: true
  },
  {
    value: PAYMENT_DUE_TYPE_ENUM.MONTHS_AFTER_PREVIOUS,
    label: 'Months after previous',
    isSubsequentInstallmentsOnly: true
  },
  {
    value: PAYMENT_DUE_TYPE_ENUM.DAYS_AFTER_REGISTRATION,
    label: 'Days after registration',
    isFirstInstallmentOnly: true
  },
  {
    value: PAYMENT_DUE_TYPE_ENUM.MONTHS_AFTER_REGISTRATION,
    label: 'Months after registration',
    isFirstInstallmentOnly: true
  },
  {
    value: PAYMENT_DUE_TYPE_ENUM.FIXED_DATE,
    label: 'Fixed date'
  }
];

const WEBSITE_PAYMENT_STATUS_ENUM = {
  SCHEDULED: '1',
  PENDING: '2',
  PAID: '3',
  FAILED: '4',
  CANCELLED: '5',
  REFUNDED: '6'
};

const WEBSITE_PAYMENT_STATUS_LIST = [
  {
    value: WEBSITE_PAYMENT_STATUS_ENUM.SCHEDULED,
    label: 'Scheduled',
    color: '#000'
  },
  {
    value: WEBSITE_PAYMENT_STATUS_ENUM.PENDING,
    label: 'Pending',
    color: 'dodgerblue'
  },
  {
    value: WEBSITE_PAYMENT_STATUS_ENUM.PAID,
    label: 'Paid',
    color: 'green'
  },
  {
    value: WEBSITE_PAYMENT_STATUS_ENUM.FAILED,
    label: 'Failed',
    color: '#C40000'
  },
  {
    value: WEBSITE_PAYMENT_STATUS_ENUM.CANCELLED,
    label: 'Cancelled',
    color: '#C40000'
  },
  {
    value: WEBSITE_PAYMENT_STATUS_ENUM.REFUNDED,
    label: 'Refunded',
    color: '#C40000'
  }
];

const API_ERROR_CODE_ENUM = { USER_DEACTIVATED: 'SHUserDeleted' };

const ACCOUNT_DEACTIVATED_MESSAGE =
  'This account has been deactivated. If you believe this is a mistake, contact support@sportsheadz.com.';

export {
  PRODUCTION,
  TESTING,
  LOCAL_API,
  CONSOLE_DEBUG,
  COGNITO_SETTING_DEV,
  COGNITO_SETTING_PROD,
  META_PIXEL_ID,
  S3_PUBLIC_URL,
  SPORTSHEADZ_WEBSITE_URL,
  PASSWORD_CONSTRAINTS,
  REG_ASSOCIATION_SOCIAL_TYPES,
  TEST_CASE_DATA,
  CANADA_PROVINCE_LIST,
  USA_STATE_LIST,
  PAYMENT_TYPE_ENUM,
  OFFLINE_PAYMENT_TYPES,
  REG_GENDER_TYPES,
  REG_FORM_SORT_TYPES,
  REG_ASSOCIATION_SAVED_TEMPLATE_INPUT_TYPE,
  PAYMENT_PROVIDERS,
  PAYMENT_PROVIDER_LIST,
  CURRENCY_TYPE_ENUM,
  CURRENCY_TYPE_LIST,
  REG_FORM_SUBMISSION_MODAL_ACTIONS_ENUM,
  PAYMENT_PROVIDER_LINE_ITEM_TYPES,
  REG_FORM_CONTROL_TYPE_ENUM,
  REG_FORM_CONTROL_TYPES,
  ANALYTIC_MERCH_PACKAGE_SHOWCASE_LOCATION_ENUM,
  REG_PERMISSION_ENUM,
  REG_PERMISSION_LIST,
  REG_SCOUT_REPORT_QUESTION_TYPE,
  DEFUALT_EVALUATION_BUTTON_OPTIONS,
  REG_SCOUT_REPORT_QUESTION_RESTRICTION_CONDITION_ENUM,
  REG_SCOUT_REPORT_QUESTION_RESTRICTION_CONDITIONS,
  REG_FORM_SUBMISSION_STATUS_ENUM,
  REG_FORM_SUBMISSION_INVOICE_STATUS_ENUM_VALUES,
  REG_FORM_SUBMISSION_INVOICE_STATUS_ENUM,
  REG_FORM_SUBMISSION_INVOICE_STATUS_LIST,
  VIEW_ACTIONS_ENUM,
  REG_RESOURCE_TYPE_ENUM,
  REG_RESOURCE_TYPE_LOG_ENUM,
  REG_EXTERNAL_CONNECTION_TYPE_ENUM,
  BULK_EDIT_FIELD_TYPE_ENUM,
  SERVICE_TYPE_ENUM,
  PLATFORM_PK_SERVICE,
  ECOM_PRODUCT_STATUS_ENUM,
  PRODUCT_CATEGORY_TYPE_ENUM,
  ECOM_ORDER_STATUS_ENUM,
  ECOM_ORDER_PRODUCT_STATUS_ENUM,
  ECOM_WEBSTORE_SECTION_BOUND_TYPE,
  ECOM_WEBSTORE_SECTION_TYPE_ENUM,
  ECOM_WEBSTORE_PAGE_TYPE_ENUM,
  ECOM_WEBSTORE_SECTION_BLOCK_TYPE_ENUM,
  ECOM_ENTITY_TYPES,
  HEADING_SIZE_STYLE_ENUM,
  ECOM_PRODUCT_BUNDLE_TYPE_ENUM,
  ECOM_PRODUCT_BUNDLE_TYPE_LIST,
  ECOM_DISCOUNT_TYPE_ENUM,
  ECOM_DISCOUNT_TYPE_LIST,
  TEAM_LAUNCH_STATUS,
  PAYMENT_PLAN_TYPE_ENUM,
  PAYMENT_PLAN_TYPE_LIST,
  PAYMENT_AMOUNT_TYPE_ENUM,
  PAYMENT_AMOUNT_TYPE_LIST,
  PAYMENT_DUE_TYPE_ENUM,
  PAYMENT_DUE_TYPE_LIST,
  WEBSITE_PAYMENT_STATUS_ENUM,
  WEBSITE_PAYMENT_STATUS_LIST,
  API_ERROR_CODE_ENUM,
  ACCOUNT_DEACTIVATED_MESSAGE
};
